<div nz-row [nzGutter]='[24, 8]'>
  <div nz-col [nzSpan]='elWidth || 6' *ngFor='let item of _fileList;let i = index;' class='file-thumbs'>
    <nz-spin [nzSpinning]="item.status === 'uploading'">
      <div *ngIf="item.fileDataType === 'img' || !item.fileDataType" class='img-box' (click)='openPreview(i)'><img [src]='item.url || item.thumbUrl'></div>
      <div class="img-box" *ngIf="item.fileDataType === 'video'">
        <video autoplay="autoplay" loop nz-tooltip
               [nzTooltipTitle]="'点击查看详情'"
               (click)="openPreviewVideo(item)">
          <source [src]="item.url">
          您的浏览器不支持 HTML5 video 标签。
        </video>
      </div>
      <div class="img-box" *ngIf="item.fileDataType === 'audio'">
        <audio controls [src]="item.url" class="audio">
          您的浏览器不支持 HTML5 audio 标签。
        </audio>
      </div>
      <div class="img-box" *ngIf="item.fileDataType !== 'img' && item.fileDataType !== 'video' && item.fileDataType !== 'audio'">
        <a class="file-link" [href]="item.url" rel="noopener" [attr.download]="getDownloadName(item)" target="_blank">
          <div class="image-bg" [ngStyle]="{ 'background-image': 'url(' + getFileIcon(item.fileDataType) + ')' }"></div>
<!--          <img *ngIf="item.fileDataType === 'pdf'" class="f-center" style="width: 85%!important;height: 85%!important;" src="assets/images/pdf.png"/>-->
<!--          <img *ngIf="item.fileDataType === 'word'" class="f-center" style="width: 85%!important;height: 85%!important;" src="assets/images/word.png"/>-->
<!--          <img *ngIf="item.fileDataType === 'excel'" class="f-center" style="width: 85%!important;height: 85%!important;" src="assets/images/excel.png"/>-->
          <div class="f-center">打开</div>
        </a>
<!--        <a [href]="item.url"-->
<!--           target="_blank"-->
<!--           class="file-link"-->
<!--           rel="noopener"-->
<!--           [attr.download]="getDownloadName(item)"-->
<!--           [ngStyle]="{ 'background-image': 'url(' + getFileIcon(item.fileDataType) + ')' }">-->
<!--          打开-->
<!--        </a>-->
      </div>
      <div *ngIf='showSelect'>
        <nz-select style='width: 100%;margin-top: 2px;margin-bottom: 4px;' [(ngModel)]='item.fileType'
                   (ngModelChange)='doEmit($event)' [nzDisabled]='disableSelect'
                   [nzDropdownClassName]="dropdownClassName">
          <nz-option *ngFor='let option of fileTypeList' [nzValue]='option.wordValue'
                     [nzLabel]='option.wordText'></nz-option>
        </nz-select>
      </div>
      <div *ngIf='!disableSelect' class='file-delete' (click)='deleteFile(i)'><i class='icon iconfont icon-close'></i>
      </div>
    </nz-spin>
  </div>
</div>

<nz-modal
  nzWidth="760"
  [nzMaskClosable]="false"
  [(nzVisible)]="isShowVideoModal"
  [nzContent]="videoModalContent"
  [nzFooter]="videoModalFooter"
  (nzOnCancel)="closeVideoModal()"
>
  <ng-template #videoModalContent>
    <div class="video-container">
      <video controls="controls" autoplay="autoplay" loop style="width: 100%;height:680px;">
        <source [src]="videoInfo.url">
        您的浏览器不支持 HTML5 video 标签。
      </video>
    </div>
  </ng-template>
  <ng-template #videoModalFooter>
    <button nz-button class="modal-cancel-btn" (click)="closeVideoModal()">关 闭</button>
  </ng-template>
</nz-modal>
